export default __webpack_public_path__ + "static/media/img_about-photos-m03.576ddc29.jpg";